var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLlmJobTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.55 18.2l5.175-6.2h-4l.725-5.674L7.825 13H11.3l-.75 5.2zm-.973-3.7H6.534a.78.78 0 01-.738-.445.769.769 0 01.058-.86l6.551-9.452c.135-.188.307-.317.516-.386a.976.976 0 01.652.017.87.87 0 01.495.414c.104.196.143.406.116.632l-.752 6.08h3.731c.357 0 .608.16.754.48.146.319.103.616-.129.892l-7.244 8.677a.984.984 0 01-.53.333.912.912 0 01-.612-.06 1.011 1.011 0 01-.463-.418.966.966 0 01-.124-.619l.762-5.284z",
    fill: "#004DC9"
  })));
}
export default __webpack_public_path__ + "assets/static/media/llm-job-tag.81d71252.svg";
export { SvgLlmJobTag as ReactComponent };